import './NotificationsForm.scss';

import React from 'react';
import { validated } from 'react-custom-validation'
import PropTypes from 'prop-types';
import update from 'immutability-helper';

import { handleCheckboxChange, handleTextChange } from 'utils/handle-changes';
import { isEmailIfTrue, isRequiredIfTrue } from 'utils/validations';

import Button from 'components/Button';
import Checkbox from 'components/Checkbox';
import Form from 'components/Form';
import FormColumn from 'components/FormColumn';
import FormRow from 'components/FormRow';
import FormValidationMessage from 'components/FormValidationMessage';
import H3 from 'components/H3';
import Label from 'components/Label';
import LoadingCircle from 'components/LoadingCircle';
import Textbox from 'components/Textbox';
import ToggleSwitch from 'components/ToggleSwitch';

class NotificationsForm extends React.Component {
    static propTypes = {
        error: PropTypes.object.isRequired,
        isSaving: PropTypes.bool.isRequired,
        onInvalid: PropTypes.func.isRequired,
        onValid: PropTypes.func.isRequired,
        setUser: PropTypes.func.isRequired,
        user: PropTypes.object.isRequired
    };

    _handleChange(name, value) {
        let newUserObj = update(this.props.user, {});
        newUserObj[name] = value;
        this.props.setUser(newUserObj);
    }

    render() {
        let { error, isSaving, onInvalid, onValid, user, $field, $validation } = this.props;

        return (
            <Form className="notifications-form">
                <FormRow columnCount={2}>
                    <FormColumn>
                        <H3>
                            Notification Settings
                        </H3>

                        <FormRow className="notifications-form__email">
                            <Textbox
                                disabled={user.notificationsUseAccountEmail === true}
                                label="Notifications Email"
                                id="txtNotificationEmail"
                                name="notificationEmail"
                                required
                                type="email"
                                validation={$validation.notificationEmail}
                                value={user.notificationEmail}
                                {...$field('notificationEmail', (event) => handleTextChange(this._handleChange.bind(this), event))}
                            />
                            <Checkbox
                                checked={user.notificationsUseAccountEmail === true}
                                id="chkNotificationsUseAccountEmail"
                                label="Same email as my account email"
                                name="notificationsUseAccountEmail"
                                onChange={(event) => handleCheckboxChange(this._handleChange.bind(this), event)}
                            />
                        </FormRow>

                        <FormRow>
                            <Label>
                                I’d like to receive the following types of notifications:
                            </Label>
                        </FormRow>

                        <FormRow className="a-form-row--toggle-switch-wrapper">
                            <ToggleSwitch
                                checked={user.notificationAccountUpdates === true}
                                label="Account Updates"
                                labelPosition="left"
                                name="notificationAccountUpdates"
                                onChange={(event) => handleCheckboxChange(this._handleChange.bind(this), event)}
                            />
                        </FormRow>

                        <FormRow className="a-form-row--toggle-switch-wrapper">
                            <ToggleSwitch
                                checked={user.notificationNewMessages === true}
                                label="New Messages"
                                labelPosition="left"
                                name="notificationNewMessages"
                                onChange={(event) => handleCheckboxChange(this._handleChange.bind(this), event)}
                            />
                        </FormRow>

                        {/*{this.props.user.isFreelancer !== true ? (
                            <FormRow className="a-form-row--toggle-switch-wrapper">
                                <ToggleSwitch
                                    checked={user.notificationBillingReminders === true}
                                    label="Billing Reminders"
                                    labelPosition="left"
                                    name="notificationBillingReminders"
                                    onChange={(event) => handleCheckboxChange(this._handleChange.bind(this), event)}
                                />
                            </FormRow>
                        ) : null}*/}

                        {/*{this.props.user.isFreelancer !== true ? (
                            <FormRow className="a-form-row--toggle-switch-wrapper">
                                <ToggleSwitch
                                    checked={user.notificationFavoriteFreelancer === true}
                                    label="When favorite freelancer becomes available"
                                    labelPosition="left"
                                    name="notificationFavoriteFreelancer"
                                    onChange={(event) => handleCheckboxChange(this._handleChange.bind(this), event)}
                                />
                            </FormRow>
                        ) : null}*/}
                    </FormColumn>
                </FormRow>

                {Object.keys(error).length > 0 ? (
                    <FormRow className="error-message">
                        <FormValidationMessage>
                            {error.friendlyMessage || error.message}
                        </FormValidationMessage>
                    </FormRow>
                ) : null}

                <FormRow className="button-wrapper">
                    <Button disabled={isSaving === true}
                            onClick={(event) => {
                                event.preventDefault();
                                this.props.$submit(onValid, onInvalid);
                            }}
                            type="submit">
                        Update
                        {isSaving === true ? <LoadingCircle innerColor="#ffffff" outerColor="#ffffff" /> : null}
                    </Button>
                </FormRow>
            </Form>
        );
    }
}

function notificationsFormValidationConfig(props) {
    const { notificationEmail, notificationsUseAccountEmail } = props.user;

    return {
        fields: ['notificationEmail'],
        validations: {
            notificationEmail: [
                [isRequiredIfTrue, notificationEmail, notificationsUseAccountEmail !== true, 'Please specify an email address to use for notifications (if not your account email).'],
                [isEmailIfTrue, notificationEmail, notificationsUseAccountEmail !== true,]
            ]
        }
    }
}

export default NotificationsForm = validated(notificationsFormValidationConfig)(NotificationsForm);



// WEBPACK FOOTER //
// ./src/containers/Accounts/Edit/NotificationsForm.js